import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { LoaderComponent } from '../../../../shared/general/components/loader/loader.component';
import { Router } from '@angular/router';
import { GtmService } from '../../../../core/services/gtm.service';

@Component({
  selector: 'app-publish-property',
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    LoaderComponent
  ],
  templateUrl: './publish-property.html',
  styleUrl: './publish-property.scss',
})
export class PublishProperty implements OnInit {
  private router = inject(Router);

  private gtm = inject(GtmService);
  @Input() id: string | null = null;

  today: Date = new Date();
  oneYearLater: Date = new Date(this.today);
  
  constructor() {
    this.oneYearLater.setFullYear(this.oneYearLater.getFullYear() + 1);
  }

  ngOnInit(): void {
    this.gtm.pageView({
      page_path: `/publish/${this.id}`,
      page_title: 'Horizinns | Publish Property'
    });
  }

  onContinue() {
    // Your logic: navigate to payment, open dialog, etc.
    console.log('User clicked Continue — start activation flow', this.id);
    this.router.navigate([`/payment/${this.id}`]);
  }
}
